class CollectionGridHover {
    constructor() {
      this.hoverOn = false;
      this.isMobile = window.innerWidth <= 989;
      this.collectionItems = document.querySelectorAll('.collection-grid__item[data-collection-handle]');
      this.subCollectionsWrap = document.querySelector('.sub_collections--wrap.sub_collections');
      this.collectionContainer = document.querySelector('.collection-grid__container');
      
      if (this.collectionItems.length > 0) {
        this.init();
      }
    }
  
    init() {
      this.bindEvents();
      // Listen for window resize to update mobile state
      window.addEventListener('resize', () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 989;
        
        // If switching between mobile and desktop, reinitialize events
        if (wasMobile !== this.isMobile) {
          this.disableAllActiveEls();
          this.hoverOn = false;
        }
      });
    }
  
    bindEvents() {
      if (this.isMobile) {
        this.bindClickEvents();
      } else {
        this.bindHoverEvents();
      }
    }
  
    bindClickEvents() {
      // For mobile: click to toggle subcollections
      this.collectionItems.forEach(item => {
        item.addEventListener('click', (event) => {
          // Don't prevent default if clicking on a subcollection link
          if (event.target.closest('.collection-grid__subcollection-link')) {
            return;
          }
          
          event.preventDefault();
          const target = event.currentTarget;
          const mobileSubWrap = target.querySelector('.sub_collections--wraps.sub_collections-inner');
          const isCurrentlyActive = mobileSubWrap && mobileSubWrap.classList.contains('active');
          
          if (isCurrentlyActive) {
            // If clicking the same item, close it
            this.disableAllActiveEls();
            this.hoverOn = false;
          } else {
            // If clicking a different item, show its subcollections
            this.disableAllActiveEls();
            target.classList.add('active');
            this.showMobileSubCollections(target);
            this.hoverOn = true;
          }
        });
      });

      // Close subcollections when clicking outside
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.collection-grid__item[data-collection-handle]') && 
            !event.target.closest('.sub_collections--wraps.sub_collections-inner')) {
          this.disableAllActiveEls();
          this.hoverOn = false;
        }
      });
    }
  
    bindHoverEvents() {
      // Only bind hover events if subCollectionsWrap exists (for desktop)
      if (!this.subCollectionsWrap) return;
      
      // Container mouse leave event
      if (this.collectionContainer) {
        this.collectionContainer.addEventListener('mouseleave', (event) => {
          setTimeout(() => {
            this.disableAllActiveEls();
            this.hoverOn = false;
          }, 120);
        });
      }

      // Sub collections wrapper mouse leave
      this.subCollectionsWrap.addEventListener('mouseleave', (event) => {
        if (event.relatedTarget  == null || event.relatedTarget  == undefined) {
          this.disableAllActiveEls();
          this.hoverOn = false;
          return;
        }

        if (!event.relatedTarget .closest('.collection-grid__item[data-collection-handle]') || 
            (event.relatedTarget .closest('.collection-grid__item[data-collection-handle]') && 
             !event.relatedTarget .closest('.collection-grid__item[data-collection-handle]').classList.contains('active'))) {
          this.disableAllActiveEls();
          this.hoverOn = false;
        }
      });

      // Collection items events
      this.collectionItems.forEach(item => {
        // Mouse enter
        item.addEventListener('mouseenter', (event) => {
          if (!this.hoverOn && event.target.closest('.collection-grid__item[data-collection-handle]')) {
            this.disableAllActiveEls();

            let target = event.currentTarget;
            target.classList.add('active');

            setTimeout(() => {
              this.showSubCollections(target);
            }, 100);

            this.subCollectionsWrap.classList.add('active');
            this.hoverOn = true;
          }
        });

        // Mouse leave
        item.addEventListener('mouseleave', (event) => {
          if (event.relatedTarget  == null || event.relatedTarget  == undefined) {
            this.disableAllActiveEls();
            this.hoverOn = false;
            return;
          }

          if (event.target && event.target.closest('.collection-grid__item[data-collection-handle]')) {
            if (!event.relatedTarget .closest('.sub_collections--wrap.sub_collections.active')) {
              this.hoverOn = false;
              this.disableAllActiveEls();
            }
          }
        });
      });
    }
  
    showSubCollections(targetItem) {
      const collectionHandle = targetItem.getAttribute('data-collection-handle');
      if (!collectionHandle) return;

      // Find the matching subcollection div
      const targetSubCollection = this.subCollectionsWrap.querySelector(`[data-collection-handle="${collectionHandle}"]`);
      
      if (targetSubCollection) {
        // Hide all subcollections first
        const allSubCollections = this.subCollectionsWrap.querySelectorAll('.collection-grid__subcollections');
        allSubCollections.forEach(subCol => {
          subCol.style.display = 'none';
          subCol.classList.remove('active');
        });

        // Show and activate the target
        targetSubCollection.style.display = 'block';
        targetSubCollection.classList.add('active');
      }
    }

    showMobileSubCollections(targetItem) {
      // Find the mobile subcollection wrapper within this specific item
      const mobileSubCollectionWrap = targetItem.querySelector('.sub_collections--wraps.sub_collections-inner');
      
      if (mobileSubCollectionWrap) {
        // Show the mobile subcollections
        mobileSubCollectionWrap.style.display = 'block';
        mobileSubCollectionWrap.classList.add('active');
        
        // Calculate and set min-height for mobile subcollections
        const subCollectionsList = mobileSubCollectionWrap.querySelector('.collection-grid__subcollections-list');
        const subCollectionsContent = mobileSubCollectionWrap.querySelector('.collection-grid__subcollections-content');
        
        if (subCollectionsList && subCollectionsContent) {
          // Get the actual height of the list
          const listHeight = subCollectionsList.scrollHeight;
          // Set min-height on the content wrapper
          subCollectionsContent.style.minHeight = listHeight + 'px';
        }
      }
    }
  
    disableAllActiveEls() {
      // Remove active class from all collection items
      this.collectionItems.forEach(el => {
        if (el.classList.contains('active')) {
          el.classList.remove('active');
        }
        
        // Hide mobile subcollections for all items
        const mobileSubCollectionWrap = el.querySelector('.sub_collections--wraps.sub_collections-inner');
        if (mobileSubCollectionWrap) {
          mobileSubCollectionWrap.style.display = 'none';
          mobileSubCollectionWrap.classList.remove('active');
        }
      });

      // Hide and deactivate desktop subcollections wrapper (if exists)
      if (this.subCollectionsWrap) {
        this.subCollectionsWrap.classList.remove('active');
        
        // Hide all individual subcollections
        const allSubCollections = this.subCollectionsWrap.querySelectorAll('.collection-grid__subcollections');
        allSubCollections.forEach(subCol => {
          subCol.style.display = 'none';
          subCol.classList.remove('active');
        });
      }
    }
  }
  
// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CollectionGridHover();
});

// Also handle if DOM is already loaded
if (document.readyState !== 'loading') {
  new CollectionGridHover();
}